import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';

const OAuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // This page should never be reached as OAuth flows go through Supabase
    // Redirect to oauth-complete which handles the proper flow
    console.log('🔄 OAuth callback page reached - redirecting to oauth-complete');
    navigate('/oauth-complete' + window.location.search);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <Loader2 className="h-12 w-12 text-primary mx-auto mb-4 animate-spin" />
          <CardTitle>Processing OAuth...</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-center text-muted-foreground">
            Redirecting to complete your connection...
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default OAuthCallback;